import React, { useContext } from 'react';
import { Clock } from 'lucide-react';
import { Button } from './ui/button';
import { I18nContext } from '../context/translations/TranslationsContext.context';

/**
 * ⚠️ UX SCAFFOLD (tarea Notion "Definimos MVP rescates") — paso final
 * compartido por los 3 modales de solicitud de rescate
 * (SolicitarRescatePorMotivoDialogV2, RescueRequestDialogV2,
 * ConfigurarRentaMensualDialogV2), para CUALQUIER operación (nueva solicitud,
 * cambio de motivo, guardar/pausar/reactivar renta): confirma que la petición
 * se recibió y que el equipo contactará para pedir la documentación
 * necesaria, además del plazo de tramitación. La solicitud queda guardada
 * como movimiento "Pendiente" (ver `saveRescueRequest`/`RescueRequestStatus`
 * en rescueDocsCatalog.ts) hasta que se confirme — sin backend real de
 * rescates, hoy no hay nada que dispare esa confirmación automáticamente.
 */
export interface RescueRequestSubmittedV2Props {
	onClose: () => void;
	// Personaliza el título según el tipo de solicitud (nueva, cambio de
	// motivo, renta mensual...). Por defecto vale para el caso general.
	title?: string;
}

const RescueRequestSubmittedV2: React.FC<RescueRequestSubmittedV2Props> = ({ onClose, title }) => {
	const {
		state: { translate }
	} = useContext(I18nContext);
	const resolvedTitle = title ?? translate('rescue.submitted.defaultTitle');
	return (
		<div className="mt-2 py-4 flex flex-col items-center text-center gap-4">
			<div className="w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center">
				<Clock className="w-7 h-7 text-primary" aria-hidden="true" />
			</div>
			<div className="space-y-1.5">
				<h3 className="font-heading font-semibold text-lg text-foreground">{resolvedTitle}</h3>
				<p className="text-sm text-muted-foreground max-w-sm">
					{translate('rescue.submitted.body1')}
				</p>
				<p className="text-sm text-muted-foreground max-w-sm">
					{translate('rescue.submitted.processingTime').split('{{time}}')[0]}
					<span className="font-medium text-foreground">
						{translate('rescue.processingTimeLabel')}
					</span>
					{translate('rescue.submitted.processingTime').split('{{time}}')[1]}{' '}
					{translate('rescue.submitted.statusPrefix')}{' '}
					<span className="font-medium text-foreground">
						{translate('rescue.submitted.pendingWord')}
					</span>{' '}
					{translate('rescue.submitted.statusSuffix')}
				</p>
			</div>
			<Button className="w-full max-w-xs mt-2" onClick={onClose}>
				{translate('rescue.submitted.closeButton')}
			</Button>
		</div>
	);
};

export default RescueRequestSubmittedV2;
